import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-send-reports-email-dialog',
  templateUrl: './send-reports-email-dialog.component.html',
  styleUrls: ['./send-reports-email-dialog.component.scss'],
})
export class SendReportsEmailDialogComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {}
}
